module.exports = __webpack_public_path__ + "img/chatButton.56763819.png";